import React from 'react';
import { STAFFING_STEPS } from '../mock';

export default function StaffingModel() {
  return (
    <section id="staffing" className="py-24 md:py-32 border-b border-black/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="eyebrow mono-font text-black/60">The Staffing Model</div>
          <h2 className="display-font mt-8 text-[10vw] md:text-[4.4rem] leading-[0.95]">
            Talent that <span className="accent-red">ships</span> from day one.
          </h2>
          <p className="mt-8 text-black/60 max-w-md">
            Hiring is slow. Roadmaps are not. Anitix closes the gap with senior engineers who embed into your team, own outcomes and disappear the moment you no longer need them.
          </p>
          <img
            src="https://images.unsplash.com/photo-1489875347897-49f64b51c1f8?auto=format&fit=crop&w=900&q=80"
            alt="Engineer at work"
            className="mt-10 rounded-lg w-full max-w-md h-64 object-cover"
            style={{ filter: 'grayscale(20%)' }}
          />
        </div>

        <div className="lg:col-span-7 lg:pl-8">
          <div className="divide-y divide-black/10">
            {STAFFING_STEPS.map((step) => (
              <div key={step.n} className="py-8 grid grid-cols-12 gap-6 group">
                <div className="col-span-2 md:col-span-1 num-font text-3xl md:text-4xl accent-red">{step.n}</div>
                <div className="col-span-10 md:col-span-11">
                  <h3 className="display-font text-2xl md:text-[2rem] text-black">{step.title}</h3>
                  <p className="mt-3 text-black/60 max-w-2xl">{step.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
